export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/permute.js
// module id = 1399
// module chunks = 0